import React, { FC } from "react";
import MicroAppContainer from "../index";

const cschatApp: FC = () => {
  return <MicroAppContainer name="cschat" baseRouter="/mx-shop-micro/cschat" baseUrl="/cschat" />;
};
export default cschatApp;
